<template>
    <div class="page page-quote page-quote-info">
        <app-modal
            v-if="showIdIssuedModal"
            :btn-disabled="!form.id_issued"
            :btn-loading="loading"
            :has-actions="true"
            :link-text="$trans('quote.text.not_now')"
            class="quote-info-id"
            has-close-button
            @btnClick="setIdIssued(true)"
            @linkClick="setIdIssued(false)"
            @handle-close="handleClose"
        >
            <template v-slot:icon>
                <span v-html="$icon('send_clock')" />
            </template>

            <template v-slot:title>
                {{ $trans("quote.text.save_yourself") }}
            </template>

            <template v-slot:subTitle>
                {{ $trans("quote.text.lots_of_time") }}
            </template>

            <template v-slot:default>
                <div class="flex justify-center mt-20 w-full">
                    <app-date-input
                        v-model="form.id_issued"
                        :message="errors.get('id_issued')"
                        label="inputs.idIssued"
                        manual
                        cssStyle="margin: auto; width: 689px;"
                        :modal="true"
                    />
                </div>

                <div class="issued-info">
                    <div class="issued-info--icon">
                        <span v-html="$icon('lamp')"></span>
                    </div>
                    <span v-html="$trans('quote.text.info_helpful')" />
                </div>
            </template>
        </app-modal>

        <div class="quote-content">
            <div class="quote-content-inner">
                <template v-if="showExtraForm">
                    <component
                        :is="extraFormComponent"
                        v-model="extraForm"
                        :errors="errors"
                        :form="form"
                        :loading="loading"
                        @submit="submitExtraForm"
                    />
                </template>

                <template v-else>
                    <div class="flex items-center gap-6">
                        <svg
                            class="circle"
                            fill="none"
                            height="70"
                            viewBox="0 0 70 70"
                            width="70"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.5038 36.7096C11.8684 41.7034 13.8255 46.6206 17.4232 50.6463C26.0961 60.3369 40.9857 61.1803 50.6947 52.5154C59.6362 44.5406 61.0465 31.2844 54.4363 21.6705L62.6678 14.3188C73.2882 28.4951 71.4654 48.6814 58.0052 60.6915C43.7775 73.3918 21.9419 72.1649 9.23966 57.9502C3.61767 51.6623 0.729913 43.8984 0.480475 36.0865L11.5038 36.7096Z"
                                fill="#FBFBFB"
                            />
                            <path
                                d="M62.6671 13.8577C62.5519 13.8577 62.4368 13.896 62.3504 13.9727L54.1189 21.3245C53.9462 21.4778 53.9078 21.7462 54.0422 21.9379C60.5852 31.4655 59.0118 44.4629 50.3773 52.1694C40.8794 60.6426 26.2584 59.8183 17.7678 50.3386C14.3524 46.5141 12.3377 41.7887 11.9635 36.6798C11.9444 36.4402 11.7525 36.2581 11.5222 36.2485L0.498876 35.6255C0.364562 35.6255 0.239846 35.6638 0.143908 35.7597C0.0479694 35.8555 5.93935e-06 35.9801 5.91589e-06 36.1143C0.259038 44.3 3.41542 52.1694 8.88392 58.2751C15.1103 65.2434 23.6872 69.365 33.0221 69.8922C42.3569 70.4194 51.3367 67.2755 58.3114 61.0548C64.8832 55.1887 68.9798 47.1276 69.8241 38.3764C70.6683 29.6731 68.2603 21.0273 63.0316 14.0494C62.9549 13.9439 62.8302 13.8768 62.7054 13.8673C62.6863 13.8673 62.6766 13.8673 62.6575 13.8673L62.6671 13.8577ZM55.0495 21.7558L62.5999 15.0175C72.7406 28.9926 70.63 48.805 57.6974 60.3455C50.9146 66.4032 42.1746 69.4513 33.0796 68.9433C23.9942 68.4353 15.6476 64.4191 9.58425 57.6329C4.38438 51.8147 1.33355 44.3575 0.959391 36.5744L11.0617 37.1399C11.5318 42.3063 13.6041 47.0701 17.0675 50.9425C21.3463 55.7254 27.2274 58.553 33.636 58.9173C40.0447 59.2815 46.2136 57.1249 51.0009 52.8499C59.8848 44.923 61.5925 31.6189 55.0495 21.7366L55.0495 21.7558Z"
                                fill="black"
                            />
                            <path
                                d="M50.3988 17.1563C46.3407 13.6481 41.3327 11.7215 36.2287 11.4627L35.5859 0.468576C43.9326 0.612354 52.1929 3.75626 58.6304 9.80446L50.3988 17.1563Z"
                                fill="black"
                            />
                            <path
                                d="M35.5834 0.00187501C35.4587 0.00187498 35.3339 0.0498238 35.2476 0.145676C35.1612 0.241526 35.1133 0.366127 35.1133 0.500319L35.7561 11.4944C35.7656 11.7341 35.9575 11.9258 36.1974 11.9353C41.3013 12.2037 46.2325 14.1879 50.0893 17.5139C50.2716 17.6672 50.5306 17.6672 50.7129 17.5139L58.9444 10.1621C59.0404 10.0758 59.0979 9.95124 59.0979 9.81705C59.0979 9.68286 59.05 9.55824 58.954 9.47197C52.6221 3.51962 44.3234 0.155239 35.593 0.00187501L35.5834 0.00187501ZM36.6675 11.0247L36.0823 0.950821C44.2179 1.20962 51.9409 4.33435 57.9371 9.79786L50.3867 16.5362C46.53 13.3156 41.6947 11.3698 36.6675 11.0152L36.6675 11.0247Z"
                                fill="black"
                            />
                            <path
                                d="M30.1715 11.923C26.2572 12.7378 22.4868 14.5494 19.2921 17.4057C15.2435 21.0193 12.749 25.7064 11.828 30.6523L0.804688 30.0293C1.91758 22.275 5.66879 14.8465 11.9719 9.22006C17.0951 4.64797 23.2063 1.87785 29.5287 0.871415L30.1715 11.9135L30.1715 11.923Z"
                                fill="url(#paint0_linear_1043_2505)"
                            />
                            <path
                                d="M29.5292 0.419586C29.5292 0.419586 29.4812 0.419586 29.4524 0.419586C22.8327 1.47395 16.683 4.39741 11.6654 8.87365C5.53495 14.3467 1.50554 21.8423 0.344687 29.9609C0.3255 30.0951 0.363861 30.2197 0.450206 30.3251C0.53655 30.4306 0.651682 30.4881 0.785996 30.4977L11.8093 31.1207C12.0396 31.1303 12.2507 30.9673 12.2986 30.7373C13.2388 25.6763 15.762 21.1809 19.6091 17.7495C22.6312 15.0561 26.3152 13.1965 30.2679 12.3722C30.4981 12.3243 30.6517 12.1134 30.6421 11.8834L29.9993 0.841333C29.9993 0.707141 29.9321 0.582529 29.8266 0.505847C29.7402 0.438753 29.6347 0.400426 29.5292 0.400426L29.5292 0.419586ZM1.34243 29.6062C2.57044 21.8902 6.44636 14.8068 12.289 9.58294C17.0476 5.33674 22.8423 2.52831 29.0879 1.43561L29.6731 11.5479C25.7012 12.4393 22.0172 14.3468 18.9759 17.0593C15.0808 20.5387 12.4809 25.0629 11.4448 30.1622L1.34243 29.5966L1.34243 29.6062Z"
                                fill="#185AF5"
                            />
                            <defs>
                                <linearGradient
                                    id="paint0_linear_1043_2505"
                                    gradientUnits="userSpaceOnUse"
                                    x1="-1.90711"
                                    x2="33.7431"
                                    y1="15.7619"
                                    y2="15.7619"
                                >
                                    <stop stop-color="#185AF5" />
                                    <stop offset="1" stop-color="#72E1D1" />
                                </linearGradient>
                            </defs>
                        </svg>
                        <quote-step-header
                            :showStep="false"
                            :subtitle="
                                $trans(
                                    'quote.car.user_info.fill_insurance_info'
                                )
                            "
                            :title="
                                $trans(
                                    isAgent
                                        ? 'quote.car.user_info.time_to_know-agent'
                                        : 'quote.car.user_info.time_to_know'
                                )
                            "
                        ></quote-step-header>
                    </div>

                    <form class="quote-form" @submit.prevent="submit(false)">
                        <template v-if="quoteType === 'car'">
                            <div class="row-item-title mb-3">
                                {{
                                    "quote.car.past_insurance.shiabud_title"
                                        | __
                                }}
                            </div>

                            <app-text-radio-buttons
                                v-model="form.shiabud"
                                :items="shiabudItems"
                                :message="errors.get('shiabud')"
                            >
                            </app-text-radio-buttons>

                            <div class="start">
                                <div class="row-item">
                                    <app-box-input
                                        v-if="
                                            form.shiabud &&
                                                form.shiabud !== 'none'
                                        "
                                        v-model="form.shiabud_bank"
                                        :message="errors.get('shiabud_bank')"
                                        placeholder="quote.car.enter_bank"
                                        small
                                    ></app-box-input>
                                </div>

                                <div class="row-item">
                                    <app-box-input
                                        v-if="
                                            form.shiabud &&
                                                form.shiabud === 'bank'
                                        "
                                        :message="errors.get('shiabud_branch')"
                                        placeholder="quote.car.enter_branch"
                                        small
                                        v-model="form.shiabud_branch"
                                    ></app-box-input>
                                </div>
                            </div>
                        </template>

                        <p class="message mt-9 mb-6">
                            {{ "quote.car.policy_owner_details" | __ }}
                        </p>

                        <div class="form-row">
                            <app-input
                                v-model="form.first_name"
                                :message="errors.get('first_name')"
                                label="inputs.firstName"
                            ></app-input>

                            <app-input
                                v-model="form.last_name"
                                :message="errors.get('last_name')"
                                label="inputs.lastName"
                            ></app-input>

                            <app-select
                                v-model="form.sex"
                                :items="sex"
                                :message="errors.get('sex')"
                                label="inputs.sex"
                                rounded
                            />
                        </div>

                        <div class="form-row">
                            <div class="app-input">
                                <app-date-input
                                    v-model="form.birth_date"
                                    :message="errors.get('birth_date')"
                                    icon="calendar_new"
                                    label="inputs.birthDate"
                                    manual
                                ></app-date-input>
                            </div>

                            <app-input
                                v-model="form.id_number"
                                :message="errors.get('id_number')"
                                label="inputs.idNumberShort"
                                type="number"
                            ></app-input>
                        </div>

                        <div class="form-row">
                            <app-input
                                v-model="form.phone_number"
                                :message="errors.get('phone_number')"
                                label="inputs.phoneNumber"
                                type="number"
                            ></app-input>

                            <app-input
                                v-model="form.email"
                                :message="errors.get('email')"
                                label="inputs.email"
                            ></app-input>
                        </div>

                        <p class="message mb-6">
                            {{ "quote.car.address_info" | __ }}
                        </p>

                        <div class="form-row">
                            <app-autocomplete-input
                                v-model="form.address.city"
                                :message="
                                    errors.get('address.city.value') ||
                                        errors.get('address.city.label')
                                "
                                :search-cb="searchCities"
                                label="inputs.city"
                                @reset="resetCity"
                            />

                            <app-autocomplete-input
                                v-model="form.address.street"
                                :disabled="!form.address.city"
                                :message="
                                    errors.get('address.street.value') ||
                                        errors.get('address.street.label')
                                "
                                :search-cb="searchStreets"
                                label="inputs.street"
                            />
                        </div>

                        <div class="form-row">
                            <app-input
                                v-model="form.address.number"
                                :message="errors.get('address.number')"
                                label="inputs.number"
                                type="number"
                            ></app-input>

                            <app-input
                                v-model="form.address.apartment"
                                :message="errors.get('address.apartment')"
                                label="inputs.apartment"
                                type="number"
                            ></app-input>
                        </div>

                        <div class="submit-row">
                            <app-button
                                :disabled="!validateInfo"
                                :loading="loading"
                            >
                                {{ "quote.welcome.next" | __ }}
                            </app-button>
                        </div>
                    </form>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import QuoteProgress from "./QuoteSteps/Progress";

import CarExtraForm from "./CarExtraForm";
import AppAutocompleteInput from "./Forms/AutocomplateInput";
import Label from "./Forms/Label.vue";

export default {
    props: {
        quoteType: {
            type: String,
            default: "car"
        }
    },

    components: {
        Label,
        QuoteProgress,
        CarExtraForm,
        AppAutocompleteInput
    },

    data() {
        return {
            backgroundImage: null,

            steps: window.yna.steps,

            step: window.yna.quote.step,

            loading: false,

            errors: this.$api.errors(),

            quoteId: window.yna.quote.id,

            sex: window.yna.quote.sex,

            quoteRequestId: window.yna.quote.request_id,

            redirectUrl: "",

            showIdIssuedModal: false,

            quoteType: window.yna.quote.type,

            isAgent: window.yna.isAgent,

            form: {
                first_name: "",
                last_name: "",
                sex: "",
                birth_date: null,
                id_number: "",
                id_issued: null,
                phone_number: "",
                email: "",
                quoteType: this.quoteType,
                address: {
                    city: "",
                    street: "",
                    number: "",
                    apartment: ""
                },
                shiabud: "none",
                shiabud_bank: null,
                shiabud_branch: null
            },
            showExtraForm: false,
            extraForm: null,
            returnToken: window.yna.returnToken,

        };
    },

    mounted() {
        // document.querySelector(".quote-prev-link").style.display = "flex";
        // document
        //     .querySelector(".quote-prev-link")
        //     .addEventListener("click", e => {
        //         e.preventDefault();
        //         this.prev();
        //     });
    },

    created() {
        if (window.yna.form) {
            this.form = window.yna.form.personal;
        }

        if (window.yna.extraForm) {
            this.extraForm = window.yna.extraForm;
        }
    },

    methods: {
        handleClose() {
            this.showIdIssuedModal = false;
        },
        resetCity() {
            this.form.address.city = undefined;
            this.form.address.street = undefined;
        },
        async searchCities(term) {
            if (!term) {
                return [];
            }

            const res = await this.$api.get("address/city/search?q=" + term);
            const items = res.data();

            return (items || []).map(city => ({
                value: city.code,
                id: city.id,
                label: city.name
            }));
        },

        async searchStreets(term) {
            const cityId = this.form.address.city.id;

            if (!term || !cityId) {
                return [];
            }

            const res = await this.$api.get(
                "address/street/" + cityId + "/search?q=" + term
            );
            const items = res.data();

            return (items || []).map(city => ({
                value: city.code,
                id: city.id,
                label: city.name
            }));
        },

        prev() {
            window.history.back();
        },

        setIdIssued(issued) {
            if (this.extraForm) {
                this.showExtraForm = true;
                this.showIdIssuedModal = false;
                return;
            }

            if (!issued) {
                window.location.href = this.redirectUrl;
                return;
            }

            this.submit(true);
        },

        async submitExtraForm() {
            this.loading = true;

            let url = `quote/${this.quoteRequestId}/${this.quoteId}/extra-form`;

            if (this.returnToken) {
                url += "?return_token=" + this.returnToken;
            }

            let response = await this.$api.post(
                url,
                this.extraForm
            );
            this.errors = response.errors();

            if (response.hasErrors()) {
                this.loading = false;
                return;
            }

            const canPurchase = response.data().can_purchase;

            this.loading = false;

            if (canPurchase) {
                window.location.href = this.redirectUrl;
            } else {
                const response = await this.$api.post(
                    `quote/send-lead/${this.quoteRequestId}`
                );

                window.location.href = response.data().redirect;
            }
        },

        async submit(redirect = false) {
            this.loading = true;

            let url = `quote/${this.quoteRequestId}/${this.quoteId}/info`;

            if (this.returnToken) {
                url += "?return_token=" + this.returnToken;
            }

            let response = await this.$api.post(
                url,
                this.form
            );
            this.errors = response.errors();

            if (response.hasErrors()) {
                this.loading = false;
                return;
            }

            this.loading = false;

            this.redirectUrl = response.data().redirect;

            if (this.extraForm) {
                this.showIdIssuedModal = true;
            } else {
                if (redirect) {
                    window.location.href = response.data().redirect;
                } else {
                    this.showIdIssuedModal = true;
                }
            }
        }
    },

    computed: {
        extraFormComponent() {
            const quoteType =
                this.quoteType
                    .toString()
                    .charAt(0)
                    .toUpperCase() + this.quoteType.slice(1);

            return `${quoteType}ExtraForm`;
        },
        validateInfo() {
            return (
                this.form.first_name &&
                this.form.last_name &&
                this.form.birth_date &&
                this.form.id_number &&
                this.form.phone_number &&
                this.form.email &&
                this.form.sex &&
                this.form.address.city &&
                this.form.address.street &&
                this.form.address.number &&
                this.form.address.apartment
            );
        },

        progressSteps() {
            return this.steps.filter(step => step.includeInCount === true);
        },

        background() {
            let backgroundImage = this.currentStep.background;

            if (!backgroundImage) {
                return {};
            }

            return {
                backgroundImage: `url(/images/backgrounds/${backgroundImage}.jpg)`
            };
        },

        currentStep() {
            return this.steps[this.step];
        },

        shiabudItems() {
            return [
                {
                    label: this.$trans("quote.car.bank"),
                    value: "bank"
                },
                {
                    label: this.$trans("quote.car.other"),
                    value: "other"
                },
                {
                    label: this.$trans("quote.car.no"),
                    value: "none"
                }
            ];
        },
        quoteStepThree() {
            return [
                {
                    label: this.$trans("quote.car.yes"),
                    value: true
                },
                {
                    label: this.$trans("quote.car.no"),
                    value: false
                }
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
.quote-info-id {
    .app-date-input {
        border-radius: 100px;
        border: 1px solid rgba(33, 67, 146, 0.2);
        background: $lightest-gray;
        height: 50px;
    }

    ::v-deep {
        label {
            top: -100px;
            color: rgba(0, 0, 0, 0.6);
            text-align: right;
            font-size: 16px;
            font-weight: $font-semi-bold;
        }

        input {
            height: 50px;
        }
    }

    .manual {
        width: 689px;
    }

    .issued-info {
        display: flex;
        gap: 5px;

        margin: 40px auto;
        width: 689px;
        height: 94px;
        border-radius: 5px;
        padding: 20px 25px;
        background-color: rgba(
            24,
            90,
            245,
            0.1
        ); /* Semi-transparent blue background */

        @media screen and (max-width: $mobile) {
            flex-direction: column;
            align-items: center;
            gap: 10px;
            width: 100%;
            height: auto;
        }
    }

    .issued-info--icon {
        width: 57px;
        height: 55px;
    }

    .issued-info span {
        color: $primary-blue;
        text-align: right;
        font-size: 16px;
        font-weight: $font-semi-bold;
    }
}

.start {
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    ::v-deep {
        .box-input-wrap {
            margin-top: 30px;

            & input {
                margin-top: 30px;
                background-color: $lightest-gray;
            }
        }
    }
}

.page-quote-info {
    .form-row {
        flex-direction: initial;

        .app-input,
        .app-input-select,
        .app-autocomplete-input {
            flex: 1;
        }

        &.start {
            justify-content: flex-start !important;
        }

        @media screen and (max-width: $mobile) {
            display: block !important;
        }
    }

    .quote-content {
        min-height: auto;
        height: 100%;
        width: 100%;

        .quote-content-inner {
            svg {
                @media (max-width: $tablet) {
                    display: none;
                }
            }
        }

        &-inner {
            height: 100%;

            .step-header {
                padding-bottom: 25px;
            }

            .quote-form {
                width: 100%;
                max-width: $tablet;

                @media screen and (max-width: $mobile) {
                    max-width: 100%;
                }

                .message {
                    color: $black;
                    text-align: right;
                    font-feature-settings: "clig" off, "liga" off;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: $font-semi-bold;
                    line-height: 40px;

                    &.mt-0 {
                        margin: 0 0 20px;
                    }
                }

                .form-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    flex: 1;
                    width: 100%;
                    gap: 40px;

                    &:not(:last-of-type) {
                        margin-bottom: 25px;
                    }

                    .app-date-input {
                        @media screen and (max-width: $mobile) {
                            margin: 20px auto;
                        }

                        .manual {
                            border-radius: 100px;
                            border: 1px solid rgba(33, 67, 146, 0.2);
                            background: $lightest-gray;
                        }
                    }

                    &::v-deep {
                        .app-input-select {
                            display: flex;
                            margin: auto auto 25px;
                            flex-direction: column;
                            justify-content: flex-start;

                            @media screen and (max-width: $mobile) {
                                margin: 45px auto 25px;
                                justify-content: space-between;
                            }
                        }

                        .app-input {
                            display: flex;
                            margin: auto auto 25px;
                            flex-direction: column;
                            justify-content: flex-start;

                            @media all and (max-width: 767px) {
                                justify-content: space-between;
                            }

                            .manual {
                                label {
                                    transform: translateY(-90%);
                                    position: absolute;
                                }
                            }

                            .app-date-input {
                                width: 100%;
                                border-radius: 100px;
                                border: 1px solid rgba(33, 67, 146, 0.2);
                                background: $lightest-gray;
                                //margin: inherit;
                                display: flex;
                                justify-content: flex-start;
                                align-items: center;
                                height: 50px;

                                .manual {
                                    background: green;
                                }

                                input {
                                    color: $black;
                                    font-size: 20px;
                                    font-weight: $font-light;

                                    @media all and (max-width: 767px) {
                                        font-size: 21px;
                                    }
                                }
                            }
                        }
                    }

                    .app-input-select {
                        width: 100%;
                        max-width: 390px;

                        &.label-is-up select,
                        select:focus {
                            + label {
                                font-size: 15px;
                                font-weight: bold;
                                transform: translateY(-40%);
                            }

                            + label + .line {
                                background: #0a59da;
                                width: 100%;
                            }
                        }
                    }

                    .multiple-inputs {
                        max-width: 190px;
                        width: 100%;
                        display: flex;
                        justify-content: space-between;

                        @media screen and (max-width: $mobile) {
                            max-width: 190px;
                            margin: auto;
                        }

                        .app-input {
                            max-width: 62px;
                        }
                    }
                }

                .checkbox {
                    margin-bottom: 120px;
                    display: flex;
                    justify-content: center;
                }

                .submit-row {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 50px;
                }
            }
        }
    }
}

.quote-step {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    ::v-deep {
        .form-error-message {
            padding: 10px 20px;
            border-radius: 100px;
            background-color: $error-red;
            color: white;
            margin-bottom: 25px;
        }
    }
}
</style>
